import { Field, Model, CodeModel, FIELD_TYPES } from "../../vue-ocom/schema";

export default Model("employee_manager", {
  verbose_name: "Employee Manager",
  verbose_name_plural: "Employee Managers",
  fields: [
    Field("id", {
      label: "ID",
      primary_key: true,
      readonly: true,
      hide: false,
      field_type: FIELD_TYPES.AutoNumber,
    }),

    Field("employee", {
      label: "Employee",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "Employee",
      ref_display_field: "first_name",
      default: () => {
        return null;
      },
    }),
    Field("employee_type", {
      label: "Employee Type",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "CodeEmployeeType",
      ref_display_field: "description",
      default: () => {
        return null;
      },
    }),
  ],
});
